import { configureStore } from "@reduxjs/toolkit";
import authSlice from "../features/Auth/authSlice";
import createDiscussionSlice from "../features/Modal/createDiscussionSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    modal: createDiscussionSlice,
  },
});
